<template>
    <header :class="env">
        <div id="headerInner">
            <div id="headerInnerLeft">
                <h1 class="contents logo">
                    <router-link to="/home">pochi</router-link>
                </h1>
                <div v-show="this.$store.state.isAuth">
                    <nav v-bind:class="{ 'spNavActive': spNavOpen }">
                        <ul>
                            <li class="user sp">{{ this.$store.state.userInfo.userName }} 様</li>
                            <!-- <li><router-link to="/home">ダッシュボード</router-link></li> -->
                            <li><router-link to="/roas_product" active-class="menuActive">商品別ROAS</router-link></li>
                            <!-- <li><router-link to="/roas_ad">広告用ROAS</router-link></li> -->
                            <li><router-link to="/product_ad_register" active-class="menuActive">商品設定</router-link></li>
                            <li><router-link to="/ad_cluster" active-class="menuActive">クラスタ設定</router-link></li>
                            <li><router-link to="/totalling_targets" active-class="menuActive">グループ設定</router-link></li>
                            <li class="subMenu" v-bind:class="{ 'subMenuActive': isSubmenuActiveSales }">売上入力
                                <ul>
                                    <li><router-link to="/tempo_sales">店舗売上</router-link></li>
                                    <li><router-link to="/zozo_sales">ZOZOTOWN売上</router-link></li>
                                </ul>
                            </li>
                            <li class="subMenu" v-bind:class="{ 'subMenuActive': isSubmenuActiveAds }">広告設定
                                <ul>
                                    <li><router-link to="/private_ad">自社広告費</router-link></li>
                                    <li><router-link to="/mall_ad">モール広告費</router-link></li>
                                    <!-- <li><router-link to="/private_ad_status">自社広告設定</router-link></li> -->
                                </ul>
                            </li>
                            <li><router-link to="/ad_media_api" active-class="menuActive">広告取得履歴</router-link></li>
                            <li><router-link to="/config" active-class="menuActive">設定</router-link></li>
                            <li class="subMenu" v-bind:class="{ 'subMenuActive': isSubmenuActive }">マスタ管理
                                <ul>
                                    <li><router-link to="/delivery">配送料設定</router-link></li>
                                    <li><router-link to="/service">サービス設定</router-link></li>
                                    <li><router-link to="/tempo_code">店舗コード設定</router-link></li>
                                    <li><router-link to="/ad_account">広告アカウント設定</router-link></li>
                                    <li><router-link to="/set_media">広告媒体設定</router-link></li>
                                    <template v-if="this.$store.state.isAccessable">
                                        <li><router-link to="/product_master">商品マスタ</router-link></li>
                                    </template>
                                </ul>
                            </li>
                            <!-- <li><router-link to="/alignment">GoogleAnalytics連携</router-link></li> -->
                            <li class="logout sp" @click="logout()">ログアウト</li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div id="headerInnerRight" v-show="this.$store.state.isAuth">
                <ul class="contents">
                    <li class="user">{{ this.$store.state.userInfo.userName }} 様</li>
                    <li class="logout" @click="logout()">ログアウト</li>
                </ul>
            </div>
        </div>
        <div v-show="this.$store.state.isAuth">
            <div class="headerSpNav sp" v-bind:class="{ 'spNavActive': spNavOpen }" v-on:click="spNavOpen = !spNavOpen">
                <span>MENU</span>
            </div>
        </div>
    </header>
</template>

<script>

export default {
    name: 'Header',
    data() {
        return {
            env: process.env.NODE_ENV,
            spNavOpen: false,
            isSubmenuActive: false,
            isSubmenuActiveAds: false,
            isSubmenuActiveSales: false,
        }
    },
    watch: {
        $route() {
            this.spNavOpen = false;

            //マスタ管理に下線をつける制御
            const currentUrl = window.location.href;

            if (currentUrl.includes('private_ad') || currentUrl.includes('mall_ad') || currentUrl.includes('private_ad_status')) {
                this.isSubmenuActiveAds = true;
            }
            else {
                this.isSubmenuActiveAds = false;
            }

            if (currentUrl.includes('delivery') || currentUrl.includes('service') || currentUrl.includes('ad_account') || currentUrl.includes('set_media') || currentUrl.includes('product_master')) {
                this.isSubmenuActive = true;
            }
            else {
                this.isSubmenuActive = false;
            }

            if (currentUrl.includes('tempo_sales') || currentUrl.includes('zozo_sales')) {
                this.isSubmenuActiveSales = true;
            }
            else {
                this.isSubmenuActiveSales = false;
            }
        }
    },
    methods: {
        logout() {
            this.axios.get("/api/logout")
                .then(() => {
                    this.$store.dispatch("logined", false)
                });
        }
    }
}
</script>

<style scoped lang="sass">
.sp
    display: none !important
header
    background: $mainColor
    &.development
        background: #025dad;
        background: radial-gradient(circle, #025dad 0%, $mainColor 100%);
    &.staging
        background: #adad02;
        background: radial-gradient(circle, #adad02 30%, $mainColor 100%);
    color: $whiteColor
    position: fixed
    top: 0
    width: 100%
    z-index: 999
    a
        color: $whiteColor
    #headerInner
        display: flex
        font-size: 1.3rem
        height: 50px
        position: relative
        #headerInnerLeft
            flex: 1 1 auto
            nav
                align-items: center
                display: flex
                height: 100%
                left: 150px
                position: absolute
                li
                    display: inline-block
                    margin-right: 12px
                    a
                        position: relative
                        align-items: center
                        background: $mainColor
                        display: block
                        padding: 11px 7px 10px
                        transition: 0.2s ease-out
                        &.menuActive::after
                            position: absolute
                            content: ''
                            height: 2px
                            width: 100%
                            left: 0
                            bottom: 5px
                            border-bottom: 2px solid $whiteColor
                        &:hover
                            background: $whiteColor
                            border-radius: 5px
                            color: $grayColor
                    ul
                        display: none
                        position: absolute
                        top: 100%
                        left: 0.5%
                        width: 210%
                        li
                            display: block
                    &:hover ul
                        display: block
        .subMenu
            position: relative
            align-items: center
            background: $mainColor
            display: block
            padding: 11px 7px 10px
            transition: 0.2s ease-out
            min-width: 50px;
            text-align: center;
            &.subMenuActive::after
                position: absolute
                content: ''
                height: 2px
                width: 100%
                left: 0
                bottom: 5px
                border-bottom: 2px solid $whiteColor
        #headerInnerRight
            flex: 1 0 auto
        .contents
            align-items: center
            display: flex
            height: 50px;
            position: absolute
            right: 20px
        .logo
            font-size: 2rem
            font-weight: 800
            padding-left: 20px
            left: 0
        .user
            padding-right: 20px
            right: 0
        .logout
            border: 1px solid $whiteColor
            border-radius: 5px
            cursor: pointer
            padding: 11px 7px 10px
            transition: 0.2s ease-out
            &:hover
                background: $whiteColor
                border-radius: 5px
                color: $grayColor

@include sp()
    .sp
        display: block !important
    header
        #headerInnerLeft
            nav
                visibility: hidden
                width: 100% !important
                top: 50px !important
                left: 0 !important
                height: auto !important
                padding: 20px 0 40px
                background: $grayColor
                opacity: 0
                &.spNavActive
                    visibility: visible
                    opacity: 1
                ul
                    width: 100%
                    li
                        display: block !important
                        width: 100%
                        a
                            position: relative
                            padding: 20px !important
                            background: $grayColor !important
                            border-bottom: 1px solid #bbb
                            border-radius: 0 !important
                            &:hover
                                color: $whiteColor !important
                            &.menuActive
                                background: $mainColor !important
                                border-bottom: none !important
                                &::after
                                    display: none
                            &::after
                                content: ''
                                position: absolute
                                top: 22px
                                right: 30px
                                width: 6px
                                height: 6px
                                border-top: 1px solid $whiteColor;
                                border-right: 1px solid $whiteColor;
                                transform: rotate(45deg)
                        ul
                            z-index: 5
                            left: 0 !important
                            width: 100% !important
                        &.user
                            margin: 0 0 15px !important
                            padding: 0 20px !important
                    .logout
                        width: calc(100% - 40px)
                        margin: 30px 20px 0 !important
                        padding: 15px 0
                        text-align: center
                        font-size: 12px
                        &:hover
                            background: none
                            color: $whiteColor
        .subMenu
            position: relative
            padding: 20px !important
            background: $grayColor !important
            border-bottom: 1px solid #bbb
            border-radius: 0 !important
            text-align: left !important
            &.subMenuActive
                background: $mainColor !important
                border-bottom: none !important
                &::after
                    display: none
        #headerInnerRight
            display: none
        .headerSpNav
            position: absolute
            top: 7px
            right: 20px
            display: block
            width: 36px
            height: 36px
            text-align: center
            cursor: pointer
            &.spNavActive
                span
                    &::after
                        left: 6px
                        background: url('/images/icon_close.png') no-repeat center / cover
            span
                display: block
                padding-top: 30px
                &::after
                    content: ''
                    position: absolute
                    top: 0
                    left: 7px
                    display: block
                    width: 24px
                    height: 24px
                    background: url('/images/icon_open.png') no-repeat center / cover
</style>
